import * as React from 'react'
import { FC, useCallback } from 'react'
import Button from '@mui/material/Button'
import { getStyles } from './styling'
import { useGetClosedWonQueueUrl } from '../hooks/useGetClosedWonQueueUrl'
import { useTheme } from '@mui/material/styles'

export interface Props {
  onClick?: () => void
  marginRight?: number
}

export const ClosedWonQueueLink: FC<Props> = (props) => {
  const { onClick } = props

  const closedWonQueueLink = useGetClosedWonQueueUrl()

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick()
    }
    window.open(closedWonQueueLink)
  }, [closedWonQueueLink, onClick])
  const styles = getStyles(props, useTheme())
  return (
    <Button
      sx={styles.link}
      onClick={handleClick}
      data-test-id="closed-won-queue-link"
    >
      Closed Won Queue{' '}
      <img
        src="/static-assets/icons/arrow-northeast.svg"
        style={styles.arrow}
      />
    </Button>
  )
}
